var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-cascader',{attrs:{"options":_vm.list,"load-data":_vm.loadData,"change-on-select":"","placeholder":_vm.placeholder},on:{"change":_vm.onChange},model:{value:(_vm.arr),callback:function ($$v) {_vm.arr=$$v},expression:"arr"}})
}
var staticRenderFns = []

export { render, staticRenderFns }